import React, { useState, useEffect } from 'react';
import { useClient } from '../../context/ClientContext';

export default function AdScheduleInsights({ dateRange }) {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetcher.fetchAdScheduleInsights(dateRange)
      .then(setData)
      .finally(() => setLoading(false));
  }, [dateRange]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="h-24 bg-gray-200 rounded"></div>
      </div>
    );
  }

  if (!data?.lowHours?.length || data.potentialSavings <= 0) return null;

  const currency = data.currency || '$';
  const primaryColor = brand.colors?.primary || '#2563eb';

  function formatHour(h) {
    if (h === 0) return '12am';
    if (h === 12) return '12pm';
    return h < 12 ? `${h}am` : `${h - 12}pm`;
  }

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Ad Schedule Insights
      </h3>
      <p className="text-xs text-gray-400 mb-4">Hours with spend but zero conversions</p>

      <div className="flex items-center gap-3 mb-4 p-3 rounded-lg" style={{ backgroundColor: `${primaryColor}08` }}>
        <div className="text-2xl font-bold" style={{ color: primaryColor }}>
          {currency}{data.potentialSavings.toFixed(0)}
        </div>
        <div className="text-sm text-gray-600">
          spent during hours with no conversions
        </div>
      </div>

      <div className="space-y-2">
        {data.lowHours.slice(0, 6).map((h, i) => (
          <div key={i} className="flex items-center justify-between text-sm py-1.5 border-b border-gray-50 last:border-0">
            <span className="text-gray-700">
              {h.day} {formatHour(h.hour)}–{formatHour(h.hour + 1)}
            </span>
            <div className="flex gap-3 text-xs text-gray-500">
              <span>{currency}{h.cost.toFixed(0)} spent</span>
              <span>{h.clicks} clicks</span>
            </div>
          </div>
        ))}
      </div>

      {data.lowHours.length > 6 && (
        <p className="text-xs text-gray-400 mt-2">+{data.lowHours.length - 6} more time slots</p>
      )}
    </div>
  );
}
